export const DISPONIBILIDADE_INICIO = [
  "IMEDIATA",
  "ATE_15_DIAS",
  "ATE_30_DIAS",
  "MAIS_30_DIAS",
] as const;

export type DISPONIBILIDADE_INICIO_TYPE =
  (typeof DISPONIBILIDADE_INICIO)[number];
